import { render, staticRenderFns } from "./Notifications.vue?vue&type=template&id=01f77a5e&scoped=true&"
import script from "./Notifications.vue?vue&type=script&lang=js&"
export * from "./Notifications.vue?vue&type=script&lang=js&"
import style0 from "@/assets/styles/beneficiary.css?vue&type=style&index=0&id=01f77a5e&scoped=true&lang=css&"
import style1 from "./Notifications.vue?vue&type=style&index=1&id=01f77a5e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01f77a5e",
  null
  
)

export default component.exports